import React from "react";
import DatePicker from "react-datepicker";

import cx from "classnames";
import moment from "moment";
import styles from "./styles.module.scss";

interface DatePickerProps {
  value: any;
  handleDateChange: (date: any) => void;
  className?: string;
  maxDate?: Date;
  minDate?: Date;
  customInput?: any;
}

const parseDate = (dateValue: any): Date | null => {
  if (!dateValue) return null;

  if (dateValue instanceof Date) {
    return isNaN(dateValue.getTime()) ? null : dateValue;
  }

  if (typeof dateValue === "string") {
    const parsed = new Date(dateValue);
    return isNaN(parsed.getTime()) ? null : parsed;
  }

  const momentDate = moment(dateValue);
  return momentDate.isValid() ? momentDate.toDate() : null;
};

const DatePickerComponent: React.FC<DatePickerProps> = ({
  value,
  handleDateChange,
  className,
  maxDate = moment().add(5, "years").toDate(),
  minDate = new Date(),
  customInput = <DatePickerInput />,
}) => {

  const parsedDate = parseDate(value);

  return (
    <span className={styles.datePickerContainer}>
      <DatePicker
        maxDate={maxDate}
        minDate={minDate}
        popperClassName={cx(styles.calendar, className)}
        customInput={customInput}
        dateFormat="dd MMM yyyy"
        value={
          parsedDate ? moment(parsedDate).format("DD MMM YYYY") : "Pick a date"
        }
        onChange={handleDateChange}
        selected={parsedDate}
        showYearDropdown
        yearDropdownItemNumber={15}
        scrollableYearDropdown
      />
    </span>
  );
};

const DatePickerInput = ({ value, onClick }: any) => {
  return (
    <div onClick={onClick} className={styles.datepickerValue}>
      <i className={cx("paperflite-calendar", styles.calendarIcon)}></i>
      <span className={styles.expiryDateValue}>{value}</span>
    </div>
  );
};

export default DatePickerComponent;